import React from 'react';
import s from '#components/feedback/loadingCircle/loadingCircle.module.scss';
import Spinner from '#components/feedback/spinner/Spinner';

const LoadingCircle = ({ isVisible = true }) => {
  if (!isVisible) return null;

  return (
    <div className={s.loadingOverlay}>
      <div className={s.loadingBlur} />
      <Spinner />
    </div>
  );
};

export default LoadingCircle;
